import { injectable } from "inversify";
import "reflect-metadata";
export default interface IAppConfig {
    endpointUrl: string,
}

@injectable()
export class DefaultAppConfig implements IAppConfig {
    endpointUrl: string;
    constructor() {
        this.endpointUrl ="https://dossiers.orzeon.be/";
       // this.endpointUrl = "https://localhost:44372/"
    }
}
